<div class="background-class mat-typography">
  <spe-alert [class]="apiStatus" [message]="message"></spe-alert>
  <form [formGroup]="addressDataForm" (ngSubmit)="saveInfo()">
    <spe-base-card titleLegend="Endereço da empresa">
      <div class="aligmnent-form-itens">
        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.addressType)"
        >
          <mat-label>Tipo de endereço</mat-label>
          <mat-select name="listAddressType" formControlName="addressType">
            <mat-option *ngFor="let element of listAddressType" [value]="element.value">
              {{ element.viewValue }}
            </mat-option>
          </mat-select>
          <mat-error>
            {{ validatorErrors(addressDataFormControl.addressType, submitted) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-1"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.zipCode)"
        >
          <mat-label>CEP</mat-label>
          <input matInput type="text" placeholder="Ex: 00000-000" mask="00000-000" formControlName="zipCode" />
          <mat-error>
            {{ validatorErrors(addressDataFormControl.zipCode, submitted) }}
          </mat-error>
        </mat-form-field>

        <div class="button-find">
          <button type="button" mat-button (click)="findMethod()" class="style-small-buttons high-buttons">
            Localizar
          </button>
        </div>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.street)"
        >
          <mat-label>Endereço</mat-label>
          <input matInput type="text" formControlName="street" />
          <mat-error>
            {{ validatorErrors(addressDataFormControl.street, submitted) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-1"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.number)"
        >
          <mat-label>Número </mat-label>
          <input matInput type="text" formControlName="number" maxlength="10" />
          <mat-error>
            {{ validatorErrors(addressDataFormControl.number, submitted) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.complement)"
        >
          <mat-label>Complemento</mat-label>
          <input matInput type="text" placeholder="Ex: apto., bloco, andar, etc." formControlName="complement" />
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.district)"
        >
          <mat-label>Bairro</mat-label>
          <input matInput formControlName="district" type="text" required />
          <mat-error>
            {{ validatorErrors(addressDataFormControl.district, submitted) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.city)"
        >
          <mat-label>Cidade</mat-label>
          <input matInput formControlName="city" type="text" required />
        </mat-form-field>

        <mat-form-field
          
          class="input-class-1"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.state)"
        >
          <mat-label>Estado </mat-label>
          <input matInput formControlName="state" type="text" required />
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.reference)"
        >
          <mat-label>Ponto de referência </mat-label>
          <input matInput type="text" formControlName="reference" />
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.responsible)"
        >
          <mat-label>Responsável pelo recebimento dos benefícios </mat-label>
          <input matInput type="text" formControlName="responsible" />
          <mat-error>
            {{ validatorErrors(addressDataFormControl.responsible, submitted) }}
          </mat-error>
        </mat-form-field>
      </div>
    </spe-base-card>

    <div class="space-buttons">
      <button type="button" mat-button (click)="returnButton()" class="style-small-buttons outline-buttons">
        Voltar
      </button>
      <button
        type="submit"
        mat-button
        class="black-style-button button-width-0"
        [ngClass]="{ caixaButton: sigla == 'CAIXA' }"
      >
        Salvar alterações
      </button>
    </div>
  </form>
</div>
